import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as PricesActions from './prices.actions';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { ContractManagementApiService } from './../../../app/@shared/services/contractmanagementapi.service';
import { getAccountListConfig } from '../account/account.selectors';
import { loginSuccess } from '../auth/auth.actions';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api';
@Injectable()
export class PricesEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly contractmanagementapi: ContractManagementApiService
  ) { }

  loadLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PricesActions.loadPrices, loginSuccess),
      withLatestFrom(this.store.select(getAccountListConfig)),
      concatMap(
        action =>
          this.contractmanagementapi.get<contractmanagement_api.PaginatedPricelistPricesResponse>('/management/v2/partner/prices', {}).pipe(
            map(result => {


              return PricesActions.loadPricesSuccess({
                links: result.links,
                data: result.data,
                meta: result.meta
              });
            }),
            catchError(error => of(PricesActions.loadPricesFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );
}
